export enum Permission {
  Admin = 'admin_panel.legacy_permission',
  RecipesView = 'recipes.view',
  RecipesModify = 'recipes.modify',
}
